// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown[data-v-7362b90e] {\n  border: 1px solid #81CF1F !important;\n  border-left-width: 0 !important;\n  border-radius: 0 8px 8px 0 !important;\n}\n[data-v-7362b90e] .p-dropdown .p-dropdown-label {\n  font-size: 18px;\n  font-weight: bold;\n}\n[data-v-7362b90e] .p-button:not(.p-button-icon-only) {\n  border-radius: 5px !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
